import { Routes, Route, Navigate } from "react-router-dom";

import NotFoundPage from "./../../pages/Page/NotFoundPage/NotFoundPage";
import FAQPublic from "../../pages/Public/FAQPublic/FAQPublic";
import TermsPublic from "../../pages/Public/TermsPublic/TermsPublic";
import PublicLayout from "../../layouts/PublicLayout/PublicLayout";
import AboutUsPublic from "../../pages/Public/AboutUsPublic/AboutUsPublic";
import VerifyPaymentPublic from "../../pages/Public/VerifyPaymentPublic/VerifyPaymentPublic";
import VerifyPaymentPublicContext from "../../context/PublicContext/VerifyPaymentPublicContext/VerifyPaymentPublicContext";
// import CategoryPublicContext from "../../context/PublicContext/CategoryPublicContext/CategoryPublicContext";
// import CategoriesPublic from "../../pages/Public/CategoriesPublic/CategoriesPublic";
// import ProductPublicContext from "../../context/PublicContext/ProductPublicContext/ProductPublicContext";
// import ProductsPublic from "../../pages/Public/ProductsPublic/ProductsPublic";
// import ProductPublic from "../../pages/Public/ProductPublic/ProductPublic";

const PublicContainer = () => {
  return (
    <PublicLayout>
      <Routes>
        {/* Home */}
        <Route index element={<Navigate to="/auth/login" replace />} />

        {/* Category */}
        {/* {["/category", "/category/:category/category"].map((path) => (
        <Route
          path={path}
          element={
            <CategoryPublicContext>
              <CategoriesPublic />
            </CategoryPublicContext>
          }
        />
      ))} */}

        {/* Products */}
        {/* {["/product", "/product/:category/category"].map((path) => (
        <Route
          path={path}
          element={
            <ProductPublicContext>
              <ProductsPublic />
            </ProductPublicContext>
          }
        />
      ))} */}

        {/* Product */}
        {/* <Route
        path="/product/:product/product"
        element={
          <ProductPublicContext>
            <ProductPublic />
          </ProductPublicContext>
        }
      /> */}

        {/* Verify Payment */}
        <Route
          path="/payment/verify"
          element={
            <VerifyPaymentPublicContext>
              <VerifyPaymentPublic />
            </VerifyPaymentPublicContext>
          }
        />

        {/* FAQ */}
        <Route path="/faq" element={<FAQPublic />} />

        {/* Terms */}
        <Route path="/terms" element={<TermsPublic />} />

        {/* About Us */}
        <Route path="/about-us" element={<AboutUsPublic />} />

        {/* Not Found */}
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </PublicLayout>
  );
};

export default PublicContainer;
